import { useEffect } from 'react';
import { useToast } from './index';
import { setToastInstance } from '../../Utils/toast';

// Component to initialize toast instance
export const ToastInitializer: React.FC = () => {
  const toast = useToast();

  useEffect(() => {
    setToastInstance({
      success: toast.success,
      error: toast.error,
      warning: toast.warning,
      info: toast.info,
    });
  }, [toast]);

  return null;
};
